import { SetPageTitle } from '@game/ui';
import type { JSX } from 'react';

import { NavLink } from '@components/NavLink/NavLink';
import { LOGIN, REGISTER } from '@constants/paths';

import About from '../About/About';
import { LoginAnonymously } from '../Login/LoginAnonymously';

export const Landing = (): JSX.Element => {
  SetPageTitle('');
  return (
    <section className="container">
      <LoginAnonymously />
      <NavLink to={LOGIN}>Login</NavLink> or <NavLink to={REGISTER}>Register</NavLink>
      <About />
    </section>
  );
};
